import { translateText } from "../../../helpers/LanguageHelper";
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import { Helmet } from 'react-helmet';
import Config from '../../../helpers/Config';
import { getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen, replaceLoclizationLabel } from '../../../helpers/CommonHelper';
import GlobalEnums from '../../../helpers/GlobalEnums';
import { Collapse, Container } from "reactstrap";


const faqData = [
    {
      qus: "What Shipping Methods are Available?",
      ans: "We ship through trusted courier partners. Estimated delivery time is 1–4 days for main areas and 4–8 days for interior areas. Delivery times may vary depending on your location and courier availability.",
    },
    {
      qus: "What payment methods can I use?",
      ans: "We accept UPI payments using the payment QR code after your order is confirmed. Please complete payment before your order is shipped. Cash on delivery (COD) is not available.",
    },
    {
        qus: "Why Choose UKLButter?",
        ans: "Enjoy the authentic taste of Uthukuli with our 99% pure, natural butter, sourced directly from Uthukuli and made without preservatives.",
      },
      {
        qus: "Health Benefits of Uthukuli Butter?",
        ans: "Rich in vitamins A, D, E, and K, our butter supports healthy skin, boosts energy, and enhances immunity when consumed in moderation.",
      },
      {
        qus: "Is Uthukuli Cow Butter made from cow’s milk?",
        ans: "Yes, we use 100% fresh cow’s milk(no mixed milk) from own farms.",
      },
      {
        qus: "Packaging & Storage",
        ans: "Our butter is hygienically packed in food-grade containers to preserve its freshness and quality. Once you receive it, place the unopened container in the freezer for 30 minutes before opening. This helps the butter firm up and reduces the chance of spills if it has softened during delivery.",
      },
      {
        qus: "Can I return my order?",
        ans: "We do not accept returns because our products are consumable food items. This helps us maintain food safety, hygiene, and quality. If you have any concerns about your order, please contact us for assistance.",
      },
      {
        qus: "How can I help avoid delivery delays?",
        ans: "Delivery may be delayed by an incomplete or incorrect address, unanswered calls, or requests to reschedule. After placing your order, please keep your phone reachable and answer calls from our team or delivery partner to help ensure a smooth delivery. If you need to reschedule, please coordinate with the delivery partner. If you would like your order handed to gate security, please inform both the delivery partner and your security staff in advance, and arrange to collect it promptly. Thank you for helping us deliver your order smoothly.",
      },
      {
        qus: "Will I need to collect my order from a courier branch?",
        ans: "Doorstep delivery may not be available in some remote or interior areas. In such cases, please collect your order from the nearby courier branch designated by the delivery partner once it arrives. Please coordinate with the delivery partner to confirm the branch location and collection timings, and collect your order promptly to help maintain its freshness.",
      },
      {
        qus: "Where do you deliver ghee and butter?",
        ans: "Our ghee is available for delivery across India. Butter delivery is available in major cities across South India and all locations within Tamil Nadu.",
      },
  ];


const FaqPage = () => {
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const [langCode, setLangCode] = useState(getLanguageCodeFromSession());
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState('All topics');
    const categories = ['All topics', 'Delivery', 'Orders & payment', 'Our products'];
    const topicCategories = ['Delivery', 'Orders & payment', 'Our products', 'Our products', 'Our products', 'Our products', 'Orders & payment', 'Delivery', 'Delivery', 'Delivery'];
    const visibleFaqs = faqData.map((faq, index) => ({ ...faq, index, category: topicCategories[index] }))
        .filter(faq => (category === 'All topics' || faq.category === category) &&
            [faq.qus, faq.ans, translateText(faq.qus), translateText(faq.ans)].join(' ').toLowerCase().includes(search.trim().toLowerCase()));
    const [id, setId] = useState(0);

    useEffect(() => {
        // declare the data fetching function
        const dataOperationFunc = async () => {
            let lnCode = getLanguageCodeFromSession();
            setLangCode(lnCode);

            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["FaqPage"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }
        }
        // call the function
        dataOperationFunc().catch(console.error);
    }, [])



    return (
        <>
            <Helmet>
                <title>{siteTitle}{translateText(" - Frequently Asked Questions (FAQ)")}</title>
                <meta name="description" content={siteTitle + " - Frequently Asked Questions (FAQ)"} />
                <meta name="keywords" content="Frequently Asked Questions, FAQ"></meta>
            </Helmet>

            <SiteBreadcrumb 
            title= {translateText(LocalizationLabelsArray.length > 0 ?
                replaceLoclizationLabel(LocalizationLabelsArray, "FAQ", "lbl_faq_pagetitle")
                :
                "FAQ")
            }
            
            parent="Home" />

            <section className="ukl-faq-page">
                <Container>
                    <header className="ukl-faq-hero">
                        <span className="ukl-faq-eyebrow">{translateText("A little help, from UKL Butter")}</span>
                        <h1>{translateText("Good questions. Clear answers.")}</h1>
                        <p>{translateText("Everything you need to know about your order, from our home in Uthukuli to yours.")}</p>
                        <label className="ukl-faq-search">
                            <i className="fa fa-search" aria-hidden="true" />
                            <span className="visually-hidden">{translateText("Search frequently asked questions")}</span>
                            <input type="search" placeholder={translateText("Search delivery, payment, storage...")} value={search} onChange={event => setSearch(event.target.value)} />
                        </label>
                    </header>
                    <div className="ukl-faq-layout">
                        <aside className="ukl-faq-sidebar">
                            <div className="ukl-faq-guide">
                                <span className="ukl-faq-guide__icon" aria-hidden="true"><i className="fa fa-shopping-basket" /></span>
                                <h2>{translateText("Just placed an order?")}</h2>
                                <p>{translateText("Please take a moment to review our FAQs for a smooth delivery.")}</p>
                                <ul>
                                    <li>{translateText("Watch for your payment QR code.")}</li>
                                    <li>{translateText("Keep your phone reachable.")}</li>
                                    <li>{translateText("Check our storage instructions.")}</li>
                                </ul>
                                <Link to={'/' + langCode + '/'}>{translateText("Continue shopping ")}<i className="fa fa-arrow-right" aria-hidden="true" /></Link>
                            </div>
                        </aside>
                        <div className="ukl-faq-content">
                            <div className="ukl-faq-topics" role="group" aria-label={translateText("Filter questions by topic")}>
                                {categories.map(topic => <button type="button" key={topic} aria-pressed={category === topic} onClick={() => setCategory(topic)}>{translateText(topic)}</button>)}
                            </div>
                            <p className="ukl-faq-count" role="status">{visibleFaqs.length} {translateText(visibleFaqs.length === 1 ? 'question' : 'questions')}</p>
                            <div className="ukl-faq-list">
                                {visibleFaqs.map(faq => (
                                    <article className={'ukl-faq-item ' + (id === faq.index ? 'is-open' : '')} key={faq.index}>
                                        <h2>
                                            <button type="button" id={'faq-question-' + faq.index} aria-expanded={id === faq.index} aria-controls={'faq-answer-' + faq.index} onClick={() => setId(id === faq.index ? null : faq.index)}>
                                                <span>{translateText(faq.qus)}</span><i className={'fa ' + (id === faq.index ? 'fa-minus' : 'fa-plus')} aria-hidden="true" />
                                            </button>
                                        </h2>
                                        <Collapse isOpen={id === faq.index} id={'faq-answer-' + faq.index} role="region" aria-labelledby={'faq-question-' + faq.index}>
                                            <div className="ukl-faq-answer"><p>{translateText(faq.ans)}</p></div>
                                        </Collapse>
                                    </article>
                                ))}
                            </div>
                            {visibleFaqs.length === 0 && <div className="ukl-faq-empty"><h2>{translateText("No matching questions")}</h2><p>{translateText("Try a different search or browse all topics.")}</p><button type="button" onClick={() => { setSearch(''); setCategory('All topics'); }}>{translateText("Show all questions")}</button></div>}
                        </div>
                    </div>
                </Container>
            </section>


        </>
    );

}

export default FaqPage;
